import React, { useMemo, useState } from "react"
import { Box, Button } from "theme-ui"
import useInterval from "../../hooks/useInterval"
import Icon from "react-icons-kit"
import { playCircle } from "react-icons-kit/fa/playCircle"
import useLang from "../../hooks/useLang"
import AniLink from "../AntiLink"

const thingsen = [
  "Digital Marketing",
  "Custom Software",
  "Web & Mobile Apps",
  "Enterprise Systems",
  "Cloud & Security",
]

const thingsar = [
  "التسويق الرقمي",
  "تطوير برمجيات مخصصة",
  "تطبيقات الويب والموبايل",
  "أنظمة مؤسسية",
  "الحلول السحابية والأمن",
]

const WelcomeArea = ({ cmsContent = null }) => {
  const isAr = useLang() === "ar"

  const [counter, setCounter] = useState(0)
  const [openmodal, setOpenmodal] = useState(false)

  const cms = cmsContent && typeof cmsContent === "object" ? cmsContent : {}
  const things = useMemo(
    () =>
      Array.isArray(cms.rotating_items) && cms.rotating_items.length
        ? cms.rotating_items
        : (isAr ? thingsar : thingsen),
    [cmsContent, isAr],
  )

  const estimateServiceText = cms.cta_button || (isAr ? "ابدأ مشروعك" : "Discuss Your Project Now")
  const slogo = cms.slogan || (isAr ? "بنشمارك! شريكك في" : "BENCHMARK! Your Partner for")
  const previewServices = cms.preview_button || (isAr ? "اكتشف خدماتنا وحلولنا" : "Explore Our Capabilities")
  const handleToggleModal = () => setOpenmodal(v => !v)

  const handleUpdateCounter = () => {
    setCounter(prev => (prev >= things.length - 1 ? 0 : prev + 1))
  }

  useInterval(handleUpdateCounter, 3000)

  const thingPositionTop = counter * 60

  return (
    <Box
      dir={isAr ? "rtl" : "ltr"}
      sx={{
        minHeight: "calc(100vh - 200px)",
        display: "flex",
        alignItems: "center",
        backgroundColor: "background",
        mt: 5,
        py: 5,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div className="container" style={{ position: "relative", zIndex: 1 }}>
        <Box
          as="h1"
          sx={{
            py: 5,
            pb: 2,
            fontSize: isAr ? ["42px", "54px", "72px"] : [4, 5, 6],
            lineHeight: isAr ? [1.5, 1.45, 1.35] : ["50px", "50px", "60px"],
            textAlign: "center",
            fontWeight: "700",
            letterSpacing: isAr ? "normal" : "-0.02em",
            fontFamily: isAr ? '"Bukra", Tahoma, Arial, sans-serif' : "inherit",
          }}
        >
          <Box
            as="span"
            sx={{
              display: "block",
              color: "#666",
              mb: isAr ? 2 : 1,
              fontWeight: "700",
              fontFamily: isAr ? '"Bukra", Tahoma, Arial, sans-serif' : "inherit",
              fontSize: isAr ? "42px" : "inherit",
            }}
          >
            {slogo}
          </Box>

          <Box
            sx={{
              position: "relative",
              height: 60,
              overflow: "hidden",
              display: "block",
              minWidth: isAr ? ["320px", "420px", "580px"] : ["260px", "360px", "480px"],
              mx: "auto",
            }}
          >
            <Box
              as="span"
              sx={{
                transition: "transform 500ms ease-in-out",
                transform: `translateY(-${thingPositionTop}px)`,
                display: "flex",
                flexDirection: "column",
              }}
            >
              {things.map((thing, index) => (
                <Box
                  key={index}
                  as="strong"
                  sx={{
                    height: 60,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    whiteSpace: "nowrap",
                    fontFamily: isAr ? '"Bukra", Tahoma, Arial, sans-serif' : "inherit",
                    background: "linear-gradient(135deg, #7e9822, #3b4c00)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    fontSize: isAr ? "25px" : "inherit",
                  }}
                >
                  {thing}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            textAlign: "center",
            color: "text",
            opacity: 0.8,
            maxWidth: isAr ? "760px" : "600px",
            margin: "0 auto",
            fontWeight: isAr ? "400" : "350",
            lineHeight: isAr ? 1.9 : 1.7,
            letterSpacing: isAr ? "normal" : "0.01em",
            fontFamily: isAr ? '"Bukra", Tahoma, Arial, sans-serif' : "inherit",
            fontSize: isAr ? "20px" : "inherit",
          }}
        >
          {cms.description ||
            (isAr
              ? "نقدم حلولاً متكاملة تجمع بين الإبداع والتقنية لتحقيق أهداف عملك"
              : "We deliver integrated solutions combining creativity and technology to achieve your business goals")}
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            mt: 3,
            gap: 3,
            flexDirection: isAr ? "row-reverse" : "row",
          }}
        >
          <Button
            onClick={handleToggleModal}
            onKeyPress={handleToggleModal}
            sx={{
              marginInlineEnd: 0,
              display: "flex",
              alignItems: "center",
              gap: 2,
              px: 3,
              py: 3,
              borderRadius: "50px",
              border: "1px solid",
              borderColor: "primary",
              backgroundColor: "transparent",
              color: "primary",
              transition: "all 0.3s ease",
              fontWeight: "500",
              letterSpacing: isAr ? "normal" : "0.02em",
              width: isAr ? "auto" : "initial",
              fontSize: 1,
              fontFamily: isAr ? '"Bukra", Tahoma, Arial, sans-serif' : "inherit",
              "& span": {
                fontFamily: isAr ? '"Bukra", Tahoma, Arial, sans-serif' : "inherit",
              },
              "&:hover": {
                backgroundColor: "white",
                color: "primary",
                transform: "translateY(-2px)",
                boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
                fontWeight: "500",
              },
            }}
            variant="outline"
          >
            <Icon size={33} icon={playCircle} />
            <span>{previewServices}</span>
          </Button>

          <AniLink
            to="/discuss-project"
            style={{ textDecoration: "none" }}
          >
            <Box
              sx={{
                padding: "21px 32px",
                backgroundColor: "primary",
                color: "white",
                borderRadius: "50px",
                fontWeight: isAr ? "normal" : "600",
                fontSize: 1,
                transition: "all 0.3s ease",
                display: "inline-block",
                border: "1px solid",
                borderColor: "primary",
                letterSpacing: "0.02em",
                fontFamily: isAr ? '"Bukra", Tahoma, Arial, sans-serif' : "inherit",
                "& span": {
                  fontFamily: isAr ? '"Bukra", Tahoma, Arial, sans-serif' : "inherit",
                },
                "&:hover": {
                  transform: "translateY(-3px)",
                  boxShadow: "0 12px 25px rgba(126, 152, 34, 0.4)",
                  backgroundColor: "primary",
                  fontWeight: isAr ? "normal" : "600",
                },
              }}
            >
              {estimateServiceText}
            </Box>
          </AniLink>
        </Box>
      </div>

      {openmodal && (
        <Box
          onClick={handleToggleModal}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            p: [2, 3, 4],
          }}
        >
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              position: "relative",
              width: ["100%", "90%", "900px"],
              aspectRatio: "16/9",
              height: ["180px", "270px", "506px"],
              borderRadius: "10px",
              overflow: "hidden",
              boxShadow: "0 20px 40px rgba(0,0,0,0.5)",
              backgroundColor: "#000",
            }}
          >
            <Button
              onClick={handleToggleModal}
              sx={{
                position: "absolute",
                top: 10,
                right: 10,
                zIndex: 10,
                backgroundColor: "rgba(0,0,0,0.7)",
                color: "white",
                borderRadius: "50%",
                width: 40,
                height: 40,
                minWidth: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 4,
                fontWeight: "bold",
                border: "2px solid white",
                cursor: "pointer",
                padding: 0,
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.2)",
                },
              }}
            >
              ×
            </Button>

            <iframe
              src="https://www.youtube.com/embed/K1kLu8SBU1A?autoplay=1&rel=0&modestbranding=1"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                width: "100%",
                height: "100%",
              }}

              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
              }}
            ></iframe>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default WelcomeArea
